import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptions, Headers } from '@angular/http';
import { List } from 'immutable';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { Adjustment } from '../models/adjustment';

@Injectable()
export class AdjustmentHttpService {

  private eventsUrl: string = this.environment.baseUrl + '/api/events';
  private adjustmentUrl: string = this.eventsUrl + '/adjustments';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  addAdjustment(adjustment: Adjustment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.adjustmentUrl, JSON.stringify(adjustment.toJS()), options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getAdjustments(eventId: number): Observable<List<Adjustment>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/adjustments`)
      .map(response => List(response.json().map(element => new Adjustment(element))))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  deleteAdjustment(adjustmentId: number): Observable<any> {
    const url = `${this.adjustmentUrl}/${adjustmentId}`;
    return this.http.delete(url)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/adjustment.http.service.ts